import globalMethods from "@/globalMethods";
import {URLS} from "@/constants";


export default {
    namespaced: true,
    state: {
        salesSummary: null,
        analytics: null,
        staffPerformance: null,
        isLoading: false,
        lastFilters: null,
    },
    mutations: {
        setSalesSummary(state, data) {
            state.salesSummary = data;
        },
        setAnalytics(state, data) {
            state.analytics = data;
        },
        setStaffPerformance(state, data) {
            state.staffPerformance = data;
        },
        setIsLoading(state, value) {
            state.isLoading = value;
        },
        setLastFilters(state, filters) {
            state.lastFilters = filters;
        },
    },
    actions: {
        async getSalesSummary({commit, rootState}, params) {
            const {personalData, company} = rootState;
            const {dateFrom, dateTo, shopId, goodFormat} = params;
            const headers = {
                role: personalData.role,
                companyId: company.companyData?.token,
            };
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (timezone) headers.timezone = timezone;

            const options = {
                method: "GET",
                credentials: 'include',
                headers,
            };
            let url = `${URLS.MODEL.STATISTICS.SALES_SUMMARY_URL}?date-from=${dateFrom}&date-to=${dateTo}`;
            if (shopId && shopId !== "all") url += `&shop-id=${shopId}`;
            if (goodFormat && goodFormat !== "all") url += `&good-format=${goodFormat}`;
            return globalMethods.sendRequestToGetJson({
                url, options,
                successfulHandler: (data) => {
                    commit("setSalesSummary", data.data);
                    return {successfully: true};
                },
            });
        },
        async getAnalytics({commit, rootState}, params) {
            const {personalData, company} = rootState;
            const {dateFrom, dateTo, currency, shopId, goodFormat} = params;
            const headers = {
                role: personalData.role,
                companyId: company.companyData?.token,
            };
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (timezone) headers.timezone = timezone;

            const options = {
                method: "GET",
                credentials: 'include',
                headers,
            };
            let url = `${URLS.MODEL.STATISTICS.ANALYTICS_URL}?date-from=${dateFrom}&date-to=${dateTo}`;
            if (currency) url += `&currency=${currency}`;
            if (shopId && shopId !== "all") url += `&shop-id=${shopId}`;
            if (goodFormat && goodFormat !== "all") url += `&good-format=${goodFormat}`;
            return globalMethods.sendRequestToGetJson({
                url, options,
                successfulHandler: (data) => {
                    commit("setAnalytics", data.data);
                    return {successfully: true};
                },
            });
        },
        async getStaffPerformance({commit, rootState}, params) {
            const {personalData, company} = rootState;
            const {dateFrom, dateTo, currency, shopId, goodFormat} = params;
            const headers = {
                role: personalData.role,
                companyId: company.companyData?.token,
            };
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (timezone) headers.timezone = timezone;

            const options = {
                method: "GET",
                credentials: 'include',
                headers,
            };
            let url = `${URLS.MODEL.STATISTICS.STAFF_PERFORMANCE_URL}?date-from=${dateFrom}&date-to=${dateTo}`;
            if (currency) url += `&currency=${currency}`;
            if (shopId && shopId !== "all") url += `&shop-id=${shopId}`;
            if (goodFormat && goodFormat !== "all") url += `&good-format=${goodFormat}`;
            return globalMethods.sendRequestToGetJson({
                url, options,
                successfulHandler: (data) => {
                    commit("setStaffPerformance", data.data);
                    return {successfully: true};
                },
            });
        },
        async loadAllStatistics({dispatch, commit, rootState}, params) {
            // Don't fire requests until role + companyId are populated; otherwise
            // backend rejects with 400 "Missing or invalid role header." and the UI
            // shows generic Oops to the user.
            if (!rootState.personalData.role || !rootState.company.companyData?.token) {
                return {successfully: false, missingRole: true};
            }
            commit("setLastFilters", params);
            commit("setIsLoading", true);
            try {
                await Promise.all([
                    dispatch("getSalesSummary", params),
                    dispatch("getAnalytics", params),
                    dispatch("getStaffPerformance", params),
                ]);
            } finally {
                commit("setIsLoading", false);
            }
            return {successfully: true};
        },
    },
};
